import { Navigate } from '@sorare/routing';

import { NBA_ONBOARDING } from '@sorare/core/src/constants/__generated__/routes';

const OnboardingPage = () => {
  return <Navigate to={NBA_ONBOARDING} replace />;
};
export default OnboardingPage;
